export default __webpack_public_path__ + "static/media/Auto spares.66df8023.jpg";